"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatetimePicker = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@stitches/react");
var react_2 = require("react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledDateTimePicker = (0, react_1.styled)("input", {
    borderStyle: "solid",
    borderWidth: "1px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "fit-content",
    gap: "6px",
    color: stitches_config_1.theme.colors.gray11,
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    boxShadow: stitches_config_1.theme.shadows.shadowInner,
    background: stitches_config_1.theme.colors.white,
    padding: "8px 12px",
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "20px",
    fontFamily: "Inter",
    "&:hover": {
        background: stitches_config_1.theme.colors.gray2,
    },
    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    variants: {
        hasValue: {
            true: {
                color: stitches_config_1.theme.colors.gray12,
            },
            false: {},
        },
        error: {
            true: {
                borderColor: stitches_config_1.theme.colors.red7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.red8,
                    background: stitches_config_1.theme.colors.red2,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.red9,
                    boxShadowColor: stitches_config_1.theme.colors.error,
                    outline: "none",
                },
            },
            false: {
                borderColor: stitches_config_1.theme.colors.gray7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.gray8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.blue9,
                    boxShadowColor: stitches_config_1.theme.colors.focus,
                    outline: "none",
                },
            },
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
    defaultVariants: {},
});
var StyledText = (0, react_1.styled)(Text_1.Text, {
    variants: {
        hasValue: {
            true: {},
        },
    },
});
function DatetimePicker(props) {
    var _a;
    var ref = (0, react_2.useRef)(null);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(StyledDateTimePicker, __assign({}, props, { disabled: props.disabled, ref: ref, onClick: function () {
                ref.current && ref.current.showPicker && ref.current.showPicker();
            }, min: props.minDate, max: props.maxDate, value: props.value, onChange: function (e) { return props.onChange && props.onChange(e.target.value); }, type: props.time ? "datetime-local" : "date", placeholder: props.placeholder, hasValue: !!props.value, error: (_a = props.error) !== null && _a !== void 0 ? _a : false })) }));
}
exports.DatetimePicker = DatetimePicker;
//# sourceMappingURL=DatetimePicker.js.map